/**
 * Word Wheel top-users player search: paste a RevenueCat App User ID,
 * a session UUID, a name, or an email.
 */
export const WORD_WHEEL_PLAYER_SEARCH_PLACEHOLDER =
    "$RCAnonymousID:52d62a8c768943ad96013ab9fb4d9684";

export const WORD_WHEEL_PLAYER_SEARCH_DEBOUNCE_MS = 400;

const RC_PREFIX = /^\$?rcanonymousid:\s*/i;
const ANON_WRAPPER = /^anonymous\s*\((.+)\)\s*$/i;
const TRAILING_ELLIPSIS = /[.…]+$/u;

/**
 * Guest player label: RevenueCat App User ID when the app has sent it, otherwise the full session UUID.
 * @param {{ sessionId?: string, cloudUserId?: string, name?: string, email?: string, revenueCatAppUserId?: string }} row
 */
export function wordWheelGuestPlayerLabel(row) {
    if (row?.cloudUserId) {
        return row?.name || row?.email || "—";
    }
    const rcId = row?.revenueCatAppUserId ? String(row.revenueCatAppUserId).trim() : "";
    if (rcId) {
        return `Anonymous (${rcId})`;
    }
    const sessionId = row?.sessionId ? String(row.sessionId).trim() : "";
    if (sessionId) {
        return `Anonymous (${sessionId})`;
    }
    return row?.name || row?.email || "—";
}

/**
 * Strip wrappers that break GET query strings (`$`, `:`, `…`) so the backend
 * receives a UUID, hex id, name, or email.
 */
export function toWordWheelPlayerSearchQuery(raw) {
    let text = String(raw ?? "").trim();
    if (!text) {
        return "";
    }
    const wrapped = text.match(ANON_WRAPPER);
    if (wrapped) {
        text = String(wrapped[1] || "").trim();
    }
    text = text.replace(TRAILING_ELLIPSIS, "").trim();
    text = text.replace(RC_PREFIX, "").trim();
    return text;
}
